import { Color3 } from '@babylonjs/core/Maths/math.color';
import { CreateGround } from '@babylonjs/core/Meshes/Builders/groundBuilder';
import { GridMaterial } from '@babylonjs/materials/grid/gridMaterial';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Scene } from '@babylonjs/core/scene';

import { ERR_INVALID_ARGUMENT } from '@egr/wcf/modules/utils/error';

/**
 * Alternative to `createGrid` of wcf-core with better performance on mobile devices
 */
export function createGrid(scene: Scene, size: number, step: number = 1): Mesh {
    if (scene == null) {
        throw new Error(ERR_INVALID_ARGUMENT);
    }

    const groundMaterial: GridMaterial = new GridMaterial('groundMaterial', scene);
    groundMaterial.majorUnitFrequency = 10;
    groundMaterial.minorUnitVisibility = 0.45;
    groundMaterial.gridRatio = 0.1 * step;
    groundMaterial.backFaceCulling = true;
    groundMaterial.mainColor = new Color3(0, 0, 0);
    groundMaterial.lineColor = new Color3(0, 0, 0);
    groundMaterial.opacity = 0.26;

    const ground: Mesh = CreateGround('ground', { width: size, height: size, subdivisions: 100, updatable: false }, scene);
    ground.position.y = 0.001;
    ground.material = groundMaterial;
    ground.isPickable = false;
    ground.freezeWorldMatrix();

    return ground;
}